import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import QuickNavigation from "../components/common/quick-navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft, faFileImport, faFolderTree } from "@fortawesome/free-solid-svg-icons";
import { useHasPermission } from "../hooks/useHasPermission";

const Document: React.FC = () => {
  const canUploadDocuments = useHasPermission("documents-upload", "create");
  const canViewMoveJobs = useHasPermission("documents-move", "read");
  const canSearchIataDocuments = useHasPermission("documents-search", "read");

  const exportJobActions = [
    ...(canViewMoveJobs
      ? [{ label: "View Move Jobs", route: "/document/move-jobs" }]
      : []),
    { label: "View Export Jobs", route: "/document/exports" },
  ];

  return (
    <Box sx={{ width: "100%", mt: 3 }}>
      <Typography
        variant="h6"
        align="center"
        fontWeight={700}
        color="#fff"
        sx={{ mb: 3 }}
      >
        Quick Navigation
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
          <QuickNavigation
            icon={<FontAwesomeIcon icon={faFolderTree} />}
            actions={[{ label: "View Documents", route: "/document/search" }]}
            title="Documents Search, View, Download"
            description="Manage  document by search filters"
          />
        </Grid>
        {canUploadDocuments && (
          <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
            <QuickNavigation
              icon={<FontAwesomeIcon icon={faFileImport} />}
              actions={[{ label: "Upload Documents", route: "/document/upload" }]}
              title="Upload Documents"
              description="Upload Document Manually "
            />
          </Grid>
        )}
        {canSearchIataDocuments && (
        <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
          <QuickNavigation
            icon={<FontAwesomeIcon icon={faClockRotateLeft} />}
            actions={exportJobActions}
            title="Jobs"
            description="Track folder export progress and download completed zip files"
          />
        </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Document;
